module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHAAAAAkAgMAAAAskVY5AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAMUExURUdwTP///////////waf0AoAAAADdFJOUwBAwJFrSWsAAABtSURBVDjLnZPBCcAwDANNM1i7/xyao66dFPoIUkH6HmeIY0VsOa7gGVDwFupIKCjUkUItyNWCXG1I1YZUnZCpEzJ1QaIuSNQXtnomCxQslcNSTSjH4ucp1hLk+uB+GdwzgXuacOsAt4KqvF/tHwg1EV4pAG/BAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/right.png
// module id = xl0W
// module chunks = 3